























import { defineComponent } from "@vue/composition-api";
import { ListFields } from "@/types";

export default defineComponent({
  name: "BaseInputRadio",
  props: {
    name: { type: String, default: "" },
    value: { type: [String, Boolean], default: "" },
    options: { type: Array as () => ListFields, required: true },
  },
  model: {
    event: "input",
    prop: "value",
  },
  methods: {
    onInput(value: string | boolean) {
      this.$emit("input", value);
    },
  },
});
